type Plain = Record<string, unknown>;

const isPlain = (v: unknown): v is Plain => typeof v === 'object' && v !== null && !Array.isArray(v);

/**
 * Deep merge for theme layering. Objects merge recursively, `undefined` never overwrites,
 * arrays and scalars replace. Returns a new object; inputs are not mutated.
 */
export function deepMerge<T extends Plain>(base: T, ...overlays: Array<Plain | undefined>): T {
  const out: Plain = { ...base };
  for (const overlay of overlays) {
    if (!overlay) continue;
    for (const [key, value] of Object.entries(overlay)) {
      if (value === undefined) continue;
      const current = out[key];
      out[key] = isPlain(current) && isPlain(value) ? deepMerge(current, value) : value;
    }
  }
  return out as T;
}
